export const matrix = [
    { value: 1, key: 'responsible', label: 'Responsible' },
    { value: 2, key: 'accountable', label: 'Accountable' },
    { value: 3, key: 'consulted', label: 'Consulted' },
    { value: 4, key: 'informed', label: 'Informed' }
]

export const complianceChip = [
    {
        name: 'Nearing Due',
        dataCount: 0,
        color: 'hsl(var(--nearing-due))'
    },
    {
        name: 'Due',
        dataCount: 0,
        color: 'hsl(var(--High))'
    },
    {
        name: 'Over Due',
        dataCount: 0,
        color: 'hsl(var(--Extreme))'
    },
    {
        name: 'Closed',
        dataCount: 0,
        color: 'hsl(var(--Low))'
    },
    {
        name: 'Before Due',
        dataCount: 0,
        color: 'hsl(var(--primary))'
    }
]

export const catgoryFunnelBox = [
    {
        label: 'Regulatory', value: 'Regulatory', checked: true
    },
    {
        label: 'Statutory', value: 'Statutory', checked: true
    },
    {
        label: 'Voluntary', value: 'Voluntary', checked: true
    }
]
export const frequencyFunnelBox = [
    {
        label: 'Weekly', value: 'Weekly', checked: true
    },
    {
        label: 'Monthly', value: 'Monthly', checked: true
    },
    {
        label: 'Quarterly', value: 'Quarterly', checked: true
    },
    {
        label: 'Half yearly', value: 'HalfYearly', checked: true
    },
    {
        label: 'Annually', value: 'Annually', checked: true
    },
    {
        label: 'Event', value: 'Event', checked: true
    }
]
export const transferType = [
    {
        label: 'Assigned',
        value: 'Assigned',
        checked: true
    },
    {
        label: 'Reassigned',
        value: 'Reassigned',
        checked: true
    }
]
export const frequencyById = [
    {
        label: 'Monthly', value: 1, checked: true
    },
    {
        label: 'Quarterly', value: 2, checked: true
    },
    {
        label: 'Half Yearly', value: 3, checked: true
    },
    {
        label: 'Annually', value: 4, checked: true
    }
]
export const holidays = [
    new Date(2025, 0, 1), // January 1
    new Date(2025, 0, 15), // January 15
    new Date(2025, 0, 26), // January 26
    new Date(2024, 11, 25) // December 25
]
export const monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ]
export const holiday = 'Holiday'
